import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../base/util/base.service';
import { URL_PRESTADOR_EXECUTANTE } from '../base/util/url-util';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class IdentificarPrestadorExecutanteService extends BaseService{
    
    constructor(public http: HttpClient,public messageService: MessageService){
        super(http,messageService);        
    }

    /**
     * Recupera a lista de prestador executante da clinica logada
     */
    recuperaListaPrestadorExecutante(){
        return this.get(URL_PRESTADOR_EXECUTANTE);
    }

}


// WEBPACK FOOTER //
// ./src/app/components/identificar-prestador-executante/identificar-prestador-executante.service.ts